"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Questions = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _InteractiveChatMessages = require("../../InteractiveChatMessages");
var _hooks = require("../../../../hooks");
var _InteractiveStreamQuestions = require("../InteractiveStreamQuestions.styled");
var _QuestionComponent = require("../../QuestionComponent");
var _DropdownSelect = require("../../../DropdownSelect");
var _utils = require("./utils");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var Questions = exports.Questions = function Questions(_ref) {
  var questions = _ref.questions,
    isAdmin = _ref.isAdmin,
    filteredType = _ref.filteredType,
    onAnswerSubmit = _ref.onAnswerSubmit,
    onArchiveClick = _ref.onArchiveClick,
    onRestoreClick = _ref.onRestoreClick,
    onLikeClick = _ref.onLikeClick,
    viewerId = _ref.viewerId;
  var _useState = (0, _react.useState)(_utils.SORT_ORDER.NEWEST),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    sort = _useState2[0],
    setSort = _useState2[1];
  var filteredQuestions = questions.filter(function (question) {
    return question.status === filteredType;
  });
  var sorted = (0, _utils.sortFn)(filteredQuestions, sort);
  var _useScrollPosition = (0, _hooks.useScrollPosition)(filteredQuestions.length),
    _useScrollPosition2 = (0, _slicedToArray2["default"])(_useScrollPosition, 3),
    ref = _useScrollPosition2[0],
    isScrolling = _useScrollPosition2[1],
    onJumpToLatest = _useScrollPosition2[2];
  var onSort = function onSort(event) {
    setSort(event.target.value);
  };
  var sortOptions = [{
    id: _utils.SORT_ORDER.NEWEST,
    label: _utils.SORT_ORDER.NEWEST,
    checked: true,
    name: 'QASort'
  }, {
    id: _utils.SORT_ORDER.OLDEST,
    label: _utils.SORT_ORDER.OLDEST,
    checked: false,
    name: 'QASort'
  }, {
    id: _utils.SORT_ORDER.POPULARITY,
    label: _utils.SORT_ORDER.POPULARITY,
    checked: false,
    name: 'QASort'
  }];
  sortOptions = sortOptions.map(function (item) {
    if (item.label !== sort) {
      item.checked = false;
    } else {
      item.checked = true;
    }
    return item;
  });
  return /*#__PURE__*/_react["default"].createElement(_InteractiveStreamQuestions.QuestionsWrapper, null, isAdmin && /*#__PURE__*/_react["default"].createElement(_InteractiveStreamQuestions.DropDownWrapper, null, /*#__PURE__*/_react["default"].createElement(_DropdownSelect.DropdownSelect, {
    options: sortOptions,
    onClick: onSort,
    type: "radio",
    position: "right"
  })), /*#__PURE__*/_react["default"].createElement(_InteractiveStreamQuestions.QuestionsContainer, {
    "data-testid": "questions-container",
    className: "questions-container",
    ref: ref,
    "aria-live": "polite"
  }, sorted.map(function (question) {
    return /*#__PURE__*/_react["default"].createElement(_QuestionComponent.QuestionComponent, (0, _extends2["default"])({
      isAdmin: isAdmin,
      key: question._id
    }, question, {
      isLiked: !!viewerId && question.likes.includes(viewerId),
      onAnswerSubmit: onAnswerSubmit,
      onArchiveClick: onArchiveClick,
      onRestoreClick: onRestoreClick,
      onLikeClick: onLikeClick,
      likesCount: question.likes.length
    }));
  })), isScrolling && /*#__PURE__*/_react["default"].createElement(_InteractiveChatMessages.ScrollButton, {
    onJumpToLatest: onJumpToLatest
  }));
};